import { render, staticRenderFns } from "./teilnehmer-feld.vue?vue&type=template&id=c4b408fc&scoped=true"
import script from "./teilnehmer-feld.vue?vue&type=script&lang=js"
export * from "./teilnehmer-feld.vue?vue&type=script&lang=js"
import style0 from "./teilnehmer-feld.vue?vue&type=style&index=0&id=c4b408fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b408fc",
  null
  
)

export default component.exports